// extracted by mini-css-extract-plugin
module.exports = {"screeningQuestion":"Yourself_screeningQuestion__Tr7jx","section":"Yourself_section__1tFvg"};